//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React, { ForwardedRef, forwardRef } from 'react';
import { FieldPath, FieldValues } from 'react-hook-form';

import { TextInput } from '@components/atoms/text-input/TextInput';
import { FormFieldControllerProps } from '@components/form/field-controller/FormFieldController';

export const FormTextInput = forwardRef(
  <T extends FieldValues, TFieldName extends FieldPath<T>>(
    props: Omit<
      React.ComponentPropsWithoutRef<typeof TextInput>,
      'onChange' | 'errorText' | 'hasError'
    > &
      FormFieldControllerProps<T, TFieldName> & { label?: React.ReactNode },
    ref: ForwardedRef<HTMLInputElement>,
  ) => {
    const { error, invalid, label, onChange, ...rest } = props;
    return (
      <TextInput
        {...rest}
        ref={ref}
        errorText={error?.message}
        hasError={invalid}
        label={label}
        onChange={onChange}
      />
    );
  },
);

FormTextInput.displayName = 'FormTextInput';
